export const tokens = {
    zeus_token: 'ZEUS_TOKEN',
    proxy_user_token: '5b7b001172be31857a6da406b30f3c5528a0ab62',
    proxy_user_sparrc_morphle_admin: 'MORPHLE_SPARRC_ADMIN_TOKEN',
    proxy_user_uscap: 'MORPHLE_USCAP_ADMIN_TOKEN'
}

